import type { Endpoint, RequestArgs, Route, Request } from '../types.no-deps'
import type { AiChatUserContext, ChatId } from '../../../shared/domain/aiChats/types.no-deps'

export const route: Route = { method: 'POST', pattern: '/api/ai-chats/:chatId/prompts' }

type Params = { chatId: ChatId }
type Body = { input: string; context?: Partial<AiChatUserContext> }
type Query = never

// This endpoint streams the response to the client and the validator doesn't like a `never` when streaming the response.
type Output = any

export type AddAiChatPromptEndpoint = Endpoint<Params, Body, Query, Output>
export const addAiChatPromptRequest = (request: Request, args: RequestArgs<AddAiChatPromptEndpoint>) =>
    request<AddAiChatPromptEndpoint>(route, args)
